import { render, staticRenderFns } from "./GymSalesDashboard.vue?vue&type=template&id=34914bdc"
import script from "./GymSalesDashboard.vue?vue&type=script&lang=js"
export * from "./GymSalesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports